import { ProductCategory, ProductTypes } from '../../types/product/product';
import { getFilteredProducts } from '../../helpers/filters';

const initialState: ProductFilterState = {
  category: '0',
  rebond: false,
  search: '',
  price: 50,
  products: [],
  filteredProducts: []
};

export interface FilterTypes {
  category: ProductCategory['id'] | '0';
  rebond: boolean;
  search: string;
  price: number;
}

export interface ProductFilterState extends FilterTypes {
  products: ProductTypes[];
  filteredProducts: ProductTypes[];
}

const productFilterReducer = (
  state: ProductFilterState = initialState,
  action: { type: string; payload: Partial<ProductFilterState> }
): ProductFilterState => {
  switch (action.type) {
    case 'CAT_FILTER':
      return {
        ...state,
        category: action.payload.category,
        filteredProducts: getFilteredProducts({
          ...state,
          category: action.payload.category
        })(state.products)
      };
    case 'REBOND_FILTER':
      return {
        ...state,
        rebond: action.payload.rebond,
        filteredProducts: getFilteredProducts({
          ...state,
          rebond: action.payload.rebond
        })(state.products)
      };
    case 'SEARCH_FILTER':
      return {
        ...state,
        search: action.payload.search,
        filteredProducts: getFilteredProducts({
          ...state,
          search: action.payload.search
        })(state.products)
      };
    case 'PRICE_FILTER':
      return {
        ...state,
        price: action.payload.price,
        filteredProducts: getFilteredProducts({
          ...state,
          price: action.payload.price
        })(state.products)
      };
    case 'SET_PRODUCTS':
      return {
        ...state,
        products: action.payload.products,
        filteredProducts: action.payload.products
      };
    case 'RESET_FILTERS':
      return {
        ...initialState,
        products: state.products,
        filteredProducts: state.products
      };
    default:
      return state;
  }
};
export default productFilterReducer;
